import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { HeaderCheckbox, Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { TimePickerField } from '../../../../_metronic/_partials/controls/forms/TimePickerField';


export const initObjectEdit = {
    id: undefined,
    // groupId: 0,
    // groupTitle: "",
    shiftCategoryId: 0,
    shiftCategoryTitle: "",
    subGroupId: 0,
    subGroupTitle: "",
    maximumOvertimeDay: "",
    maximumOvertimeMonth: "",
    maximumLeaveDay: "",
    maximumLeaveMonth: "",
    maximumLeaveYear: "",

    startTimeNightWork: "00:00:00",
    endTimeNightWork: "00:00:00",

    isNightWork: false,
    isDeleted: false
};

// export const columns = [
//     {
//         dataField: "subGroupTitle",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.SubGroup.FORM_TITLE"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "maximumOvertimeDay",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEDAY"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "maximumOvertimeMonth",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEMONTH"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "maximumLeaveDay",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEDAY"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "maximumLeaveMonth",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEMONTH"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "maximumLeaveYear",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEYEAR"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "startTimeNightWork",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.STARTTIMENIGHTWORK"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     {
//         dataField: "endTimeNightWork",
//         text: columnFormatters.translateByMessageId("MODULES.BASEINFO.GROUPSETTING.ENDTIMENIGHTWORK"),
//         sort: true,
//         sortCaret: sortCaret,
//     },
//     // {
//     //     dataField: "isDeleted",
//     //     text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
//     //     // text: "وضعیت",
//     //     sort: true,
//     //     sortCaret: sortCaret,
//     //     formatter: columnFormatters.StatusColumnFormatter,
//     // },
//     // {
//     //   dataField: "action",
//     //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
//     //   // text: "Actions",
//     //   formatter: columnFormatters.ActionsColumnFormatter,
//     //   formatExtraData: {
//     //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
//     //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
//     //   },
//     //   classes: "text-right pr-0",
//     //   headerClasses: "text-right pr-3",
//     //   style: {
//     //     minWidth: "100px",
//     //   },
//     // },
// ];



export const initObjectGet = {
    id: undefined,
    title: "",
    groupId: 0,
    groupTitle: "",
    isDeleted: false
};

export const columns = [
    {
        dataField: "title",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.SubGroup.FORM_TITLE"),
        sort: true,
        sortCaret: sortCaret,
    },

    {
        dataField: "groupTitle",
        text: columnFormatters.translateByMessageId("MODULES.BASEINFO.Group.FORM_TITLE"),
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "isDeleted",
        text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
        // text: "وضعیت",
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.StatusColumnFormatter,
    },
    // {
    //   dataField: "action",
    //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
    //   // text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
    //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
];


export const filterInitialValues = {
    filter: {
        isDeleted: "", // values => All=""/Selling=0/Sold=1
        searchText: "",
    },
    sortOrder: "asc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 10,

    whereClause: "",
    whereClauseParameters: [
    ],
    orderClause: "id desc ",
    skipCount: 0,
    takeCount: 10,
};
export const filterFields = [
    {
        name: "isDeleted",
        lable: "MODULES.GENERAL.STATUS",
        type: "select",
        list: [
            {
                value: "",
                lable: "MODULES.GENERAL.STATUSALL",
            },
            {
                value: "0",
                lable: "MODULES.GENERAL.STATUSENABLE",
            },
            {
                value: "1",
                lable: "MODULES.GENERAL.STATUSDELETED",
            },

        ],
        component: SelectStatus
    },
    {
        name: "groupId",
        lable: "MODULES.BASEINFO.Group.TITLE",
        type: "component",
        list: [],
        component: (props) =>
            <SelectObjectsField api="api/group"
                reduxState="groups"
                sname="groupId"
                {...props} />
    },
    {
        name: "searchText",
        lable: "MODULES.GENERAL.SEARCH",
        type: "text",
        list: [],
    },

];


export const prepareFilter = (queryParams, values) => {
    const { isDeleted, searchText, groupId } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};
    // Filter by isDeleted
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

    // Filter by groupId
    filter.groupId = groupId !== "" ? +groupId : 0;

    // Filter by all fields
    filter.title = searchText;
    if (searchText) {
        filter.title = searchText;
    }
    newQueryParams.filter = filter;

    let whereClause = "title.contains(@0)"
    const whereClauseParameters = [];
    whereClauseParameters.push(searchText)

    if (filter.groupId > 0) {
        whereClause = whereClause + " and groupId=@1"
        whereClauseParameters.push(filter.groupId)
    }
    else {
        whereClause = whereClause + " and groupId!=@1"
        whereClauseParameters.push(0)
    }

    if (filter.isDeleted !== undefined) {
        whereClause = whereClause + " and isDeleted=@2"
        whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
    }

    newQueryParams.whereClause = whereClause;
    newQueryParams.whereClauseParameters = whereClauseParameters;

    return newQueryParams;
};


export const formFields = [
    {
        row: 1,
        list: [
            {
                name: "shiftCategoryId",
                type: "option",
                component: (props) =>
                    <SelectObjectsField api="api/ShiftCategory"
                        reduxState="shifts"
                        sname="shiftCategoryId"
                        label={""}
                        {...props} />,
                placeholder: "MODULES.BASEINFO.SHIFT.TITLE",
                label: "MODULES.BASEINFO.SHIFT.TITLE",
                rowIdx: 1,
                class: "col-lg-3",
                relField: [],
                relValues: {}
            },
            {
                name: "maximumOvertimeDay",
                type: "text",
                component: Input,
                label: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEDAY",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEDAY",
                rowIdx: 2,
                class: "col-lg-3",
            },
            {
                name: "maximumOvertimeMonth",
                type: "text",
                component: Input,
                label: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEMONTH",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMOVERTIMEMONTH",
                rowIdx: 3,
                class: "col-lg-3",
            },
            {
                name: "maximumLeaveDay",
                type: "text",
                component: Input,
                label: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEDAY",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEDAY",
                rowIdx: 4,
                class: "col-lg-3",
            },


        ]
    },
    {
        row: 2,
        list: [

            {
                name: "maximumLeaveMonth",
                type: "text",
                component: Input,
                label: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEMONTH",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEMONTH",
                rowIdx: 5,
                class: "col-lg-3",
            },
            {
                name: "maximumLeaveYear",
                type: "text",
                component: Input,
                label: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEYEAR",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.MAXIMUMLEAVEYEAR",
                rowIdx: 6,
                class: "col-lg-3",
            },
            {
                name: "startTimeNightWork",
                type: "text",
                component: TimePickerField,
                label: "MODULES.BASEINFO.GROUPSETTING.STARTTIMENIGHTWORK",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.STARTTIMENIGHTWORK",
                rowIdx: 7,
                class: "col-lg-3",
            },
            {
                name: "endTimeNightWork",
                type: "text",
                component: TimePickerField,
                label: "MODULES.BASEINFO.GROUPSETTING.ENDTIMENIGHTWORK",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.ENDTIMENIGHTWORK",
                rowIdx: 8,
                class: "col-lg-3",
            },

        ]
    },
    {
        row: 3,
        list: [
            {
                name: "isNightWork",
                type: "component",
                component: HeaderCheckbox,
                label: "MODULES.BASEINFO.GROUPSETTING.ISNIGHTWORK",
                placeholder: "MODULES.BASEINFO.GROUPSETTING.ISNIGHTWORK",
                rowIdx: 9,
                class: "col-lg-3",
            },

        ]
    },


];

export const otherFields = [
    // {
    //   name: "description",
    //   lable: "Description",
    //   type: "textarea",
    //   as: "textarea",
    //   rowOrder: 1,
    //   rowIdx: 1,
    //   class: "form-control"
    // },

];


// export const filterInitialValues = {
//     isDeleted: "", // values => All=""/Selling=0/Sold=1
//     searchText: "",
// }
// export const filterFields = [
//     {
//         name: "isDeleted",
//         lable: "MODULES.GENERAL.STATUS",
//         type: "select",
//         list: [
//             {
//                 value: "",
//                 lable: "MODULES.GENERAL.STATUSALL",
//             },
//             {
//                 value: "0",
//                 lable: "MODULES.GENERAL.STATUSENABLE",
//             },
//             {
//                 value: "1",
//                 lable: "MODULES.GENERAL.STATUSDELETED",
//             },

//         ],
//         component: SelectStatus
//     },
//     {
//         name: "groupId",
//         lable: "MODULES.BASEINFO.DORM.TITLE",
//         type: "component",
//         list: [],
//         component: (props) =>
//             <SelectObjectsField api="api/group"
//                 reduxState="groups"
//                 sname="groupId"
//                 {...props} />
//     },
//     // {
//     //     name: "searchText",
//     //     lable: "MODULES.GENERAL.SEARCH",
//     //     type: "text",
//     //     list: [],
//     // },

// ];


// export const prepareFilter = (queryParams, values) => {
//     const { isDeleted, searchText, groupId } = values;
//     const newQueryParams = { ...queryParams };
//     const filter = {};

//     // Filter by isDeleted
//     filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

//     filter.groupId = groupId !== "" ? +groupId : 0;

//     // Filter by all fields
//     filter.subGroupTitle = searchText;
//     if (searchText) {
//         filter.subGroupTitle = searchText;
//     }
//     newQueryParams.filter = filter;

//     // let whereClause = "subGroupTitle.contains(@0)"
//     let whereClause = ""
//     const whereClauseParameters = [];
//     // whereClauseParameters.push(searchText)

//     if (filter.groupId > 0) {
//         // whereClause = whereClause + " and groupId=@0"
//         whereClause = whereClause + "groupId=@0"
//         whereClauseParameters.push(filter.groupId)
//     }
//     else {
//         // whereClause = whereClause + " and groupId!=@0"
//         whereClause = whereClause + "groupId!=@0"
//         whereClauseParameters.push(0)
//     }

//     if (filter.isDeleted !== undefined) {
//         whereClause = whereClause + " and isDeleted=@1"
//         whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
//     }

//     newQueryParams.whereClause = whereClause;
//     newQueryParams.whereClauseParameters = whereClauseParameters;

//     return newQueryParams;
// };


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
    subGroupId: Yup.number()
        .positive("پر کردن فیلد الزامی است"),

});

